import { render, staticRenderFns } from "./VarroaNewVisit.vue?vue&type=template&id=34a94f34&"
import script from "./VarroaNewVisit.vue?vue&type=script&lang=js&"
export * from "./VarroaNewVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports